<template>
  <transition name="fade">
    <div v-if="visible" class="fixed" @click="cancelPopup">
      <div class="modal-card" @click.stop>
        <h3 style="font-size: 1.25rem; font-weight: 700; color: var(--text-color-dark); margin-bottom: 0.5rem;">
          {{ title }}
        </h3>
        <p style="font-size: 14px; color: var(--text-color-light); margin-bottom: 1.75rem; line-height: 1.5;">
          {{ message }}
        </p>
        
        <div class="flex items-center gap-md justify-end">
          <button @click="cancelPopup" class="secondary_button" style="flex: 1; padding: 10px 16px;">
            {{ cancelButton }}
          </button>
          <button @click="acceptPopup" class="main_button-green" style="flex: 1; padding: 10px 16px;">
            {{ acceptButton }}
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { ref, watch, defineProps, defineEmits } from 'vue';

const props = defineProps({
  title: String,
  message: String,
  acceptButton: String,
  cancelButton: String,
});

const emit = defineEmits(['acceptCallback', 'cancelCallback']);

const visible = ref(false);

watch(() => props.title, (newVal) => {
  visible.value = !!newVal;
});

const acceptPopup = () => {
  visible.value = false;
  emit('acceptCallback');
};

const cancelPopup = () => {
  visible.value = false;
  emit('cancelCallback');
};
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}

.modal-card {
  background-color: var(--white);
  padding: 1.75rem;
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-xl);
  width: 90%;
  max-width: 420px;
  text-align: center;
  border: 1px solid var(--border-color);
  animation: slideUp 0.25s cubic-bezier(0.16, 1, 0.3, 1);
}

@keyframes slideUp {
  from { transform: translateY(12px) scale(0.98); opacity: 0; }
  to { transform: translateY(0) scale(1); opacity: 1; }
}
</style>
  